import { useShallow } from 'zustand/react/shallow';
import { ProgressBar } from 'react-bootstrap';
import { useTreeStore } from '@/frontend/store/TreeStore';
import { I18n } from '@/i18n/I18n';
import { ContainerTypes, Status } from '@/types/containerTypes';

export function ProcedureProgressBar(props: { isScaffold: boolean }) {
  const { isScaffold } = props;
  const containers = useTreeStore(useShallow((state) => state.containers.filter((container) => container.isScaffold === isScaffold && container.containerType === ContainerTypes.Step)));
  const completedItems = containers.filter(item => item.status !== Status.PENDING);
  const percent = containers.length === 0 ? 0 : Math.round((completedItems.length / containers.length) * 100);

  return (
    <div className="w-95 ps-2">
      <ProgressBar now={percent} variant="success"/>
      <div className="d-flex justify-content-center">
        <p>{I18n.get('percentComplete', { percent: String(percent) })}</p>
      </div>
    </div>
  );
}
